import * as yup from "yup";
import { getColumnDef } from "@/react/schema/schemaFields";
import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
  selectColumnFactory,
} from "@/react/components/table";

import schema from "./schema";

export default () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      {
        ...getColumnDef(yup.reach(schema, "msg_id"), "Message ID"),
        type: TYPES.ID,
        editable: false,
      },
      {
        ...getColumnDef(yup.reach(schema, "from_email"), "From"),
        type: TYPES.STRING,
        editable: false,
      },
      {
        ...getColumnDef(yup.reach(schema, "subject"), "Subject"),
        type: TYPES.STRING,
        editable: false,
      },
      {
        ...getColumnDef(yup.reach(schema, "status"), "Status"),
        type: TYPES.SELECT,
        options: {
          delivered: "delivered",
          not_delivered: "not_delivered",
        },
        editable: false,
      },
      {
        ...getColumnDef(yup.reach(schema, "opens_count"), "Opens Count"),
        type: TYPES.NUMBER,
        editable: false,
      },
      {
        ...getColumnDef(yup.reach(schema, "clicks_count"), "Clicks Count"),
        type: TYPES.NUMBER,
        editable: false,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "last_event_time"),
          "Last Event Time"
        ),
        type: TYPES.STRING,
        editable: false,
      },
    ].map(mapColumnTypes)
  );
